import React from "react";

import { Box, Slider, Typography } from "@material-ui/core";

export const MonthSlider = ({
  maxMonths = 3,
  monthRange,
  setMontRange,
  ...props
}) => {
  const maxValue = maxMonths - 1;

  const handleMonthChange = (event, newValue) => {
    const oldValue = monthRange;
    if (oldValue[0] !== newValue[0]) {
      const maxRange =
        newValue[1] - newValue[0] > maxValue
          ? newValue[0] + maxValue
          : newValue[1];
      newValue = [newValue[0], maxRange];
    } else {
      const maxRange =
        newValue[1] - newValue[0] > maxValue
          ? newValue[1] - maxValue
          : newValue[0];
      newValue = [maxRange, newValue[1]];
    }
    setMontRange(newValue);
  };

  return (
    <Box ml={1} mt={1}>
      <Typography variant="caption" color="textSecondary">
        Month Range
      </Typography>
      <Slider
        {...props}
        min={1}
        max={12}
        step={1}
        value={monthRange}
        onChange={handleMonthChange}
        valueLabelDisplay="auto" // "on" | "off" | "auto"
        fullWidth
        marks={[
          { label: `J`, value: 1 },
          { label: `F`, value: 2 },
          { label: `M`, value: 3 },
          { label: `A`, value: 4 },
          { label: `M`, value: 5 },
          { label: `J`, value: 6 },
          { label: `J`, value: 7 },
          { label: `A`, value: 8 },
          { label: `S`, value: 9 },
          { label: `O`, value: 10 },
          { label: `N`, value: 11 },
          { label: `D`, value: 12 },
        ]}
      />
    </Box>
  );
};
